export const getQuestionNumber = (currentSection, sort_index) => {
  const questions = currentSection.section.standard_question_list.map(
    (question, index) => ({ ...question, number: index + 1 })
  );
  const number = questions.find(question => question.sort_index === sort_index)
    .number;
  return number;
};
